import type { FieldErrorOptions, PctFormGroup } from '@pct-ng/form';
import { InjectionToken } from '@angular/core';

export type AbstractDetailsFormRegisterFieldErrorsResolver = (
  form: PctFormGroup,
  i18nService: FieldErrorOptions['i18nService'],
  resolveNotFoundPath: FieldErrorOptions['resolveNotFoundPath'],
) => void;

export const ABSTRACT_DETAILS_FORM_REGISTER_FIELD_ERRORS_RESOLVER =
  new InjectionToken<AbstractDetailsFormRegisterFieldErrorsResolver>(
    'ABSTRACT_DETAILS_FORM_REGISTER_FIELD_ERRORS_RESOLVER',
  );
